class PageHeaderSection extends HTMLElement {
  constructor() {
    super();

    this.isSticky = this.dataset.sticky === "true";
    this.isStickyAlways = this.dataset.stickyAlways === "true";
    this.isTransparent = this.dataset.transparent === "true";
    this.isAlwaysMobileMenu = this.dataset.alwaysMobileMenu === "true";

    this.classBodyAlwaysMobileMenu = "mobile-nav";

    this.header = document.querySelector(".page-header");
    this.desktopMenuTrigger = document.querySelector(
      ".wt-header__sticky-menu-trigger",
    );
    this.desktopMenuBar = document.querySelector(".wt-drawer--nav");

    this.enabledClass = "sticky-enabled";
    this.showClass = "sticky-show";
    this.desktopHeaderWithMenuBarClass = "page-header--sticky-show-menubar-lg";
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.disableStickyHeader();
  }

  enbleStickyHeader() {
    if (!this.header) {
      console.error("Header element not found for enabling sticky header");
      return;
    }

    document.body.classList.add("page-header-sticky");

    let prevScrollpos = window.pageYOffset;

    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
    const isMenuBarOpen = () =>
      this.header.classList.contains(this.desktopHeaderWithMenuBarClass);
    const isHeaderWithDesktopNav =
      !document.body.classList.contains("mobile-nav");
    const allLLevelsLinks =
      this.desktopMenuBar?.querySelectorAll("a[data-menu-level]");
    const onlyLevel1Links = this.desktopMenuBar?.querySelectorAll(
      "a[data-menu-level='1']",
    );

    const calculateNavbarTopMargin = () => {
      const header = document.querySelector("#header");
      const navbar = document.querySelector("#wt-drawer-nav");
      let marginTop = 0;

      if (navbar.offsetHeight > header.offsetHeight) {
        marginTop = header.offsetHeight - navbar.offsetHeight;
      } else {
        marginTop = Math.abs(navbar.offsetHeight - header.offsetHeight);
      }

      navbar.style.setProperty("--top-margin", `${marginTop}px`);

      return marginTop;
    };

    calculateNavbarTopMargin();

    const stickyHeader = {
      show: () => {
        if (this.header) this.header.classList.add(this.showClass);
        stickyHeader.visible = true;
        stickyHeader.handleBehavior();
        calculateNavbarTopMargin();
      },
      hide: () => {
        if (this.header) this.header.classList.remove(this.showClass);
        stickyHeader.visible = false;
        stickyHeader.handleBehavior();
      },
      enable: () => {
        if (this.header) this.header.classList.add(this.enabledClass);
        stickyHeader.enabled = true;
        stickyHeader.handleBehavior();
      },
      disable: () => {
        if (this.header)
          this.header.classList.remove(this.enabledClass, this.showClass);
        stickyHeader.enabled = false;
        stickyHeader.handleBehavior();
      },
      enabled: false,
      visible: true,
      handleBehavior: () => {
        if (isHeaderWithDesktopNav && isDesktop && this.header) {
          stickyHeader.log();
          if (!isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "-1");
          }
          if (isMenuBarOpen() && stickyHeader.enabled) {
            setTabindex(allLLevelsLinks, "0");
          }
          if (!stickyHeader.enabled) {
            setTabindex(onlyLevel1Links, "0");
            if (this.desktopMenuTrigger)
              setTabindex([this.desktopMenuTrigger], "-1");
          } else if (this.desktopMenuTrigger)
            setTabindex([this.desktopMenuTrigger], "0");
        }
      },
      log: () => {},
    };

    // Save the scroll handler for later removal
    this.scrollHandler = () => {
      const currentScrollPos = window.pageYOffset;
      if (!this.isStickyAlways) {
        if (prevScrollpos > currentScrollPos) {
          stickyHeader.show();
        } else {
          stickyHeader.hide();
        }
      } else {
        stickyHeader.show();
      }

      prevScrollpos = currentScrollPos;
    };

    window.addEventListener("scroll", this.scrollHandler);

    this.desktopMenuTrigger?.addEventListener("click", (e) => {
      e.preventDefault();
      this.desktopMenuBar?.classList.toggle("wt-drawer--nav-show");
      this.desktopMenuTrigger?.classList.toggle(
        "wt-header__sticky-menu-trigger--active",
      );
      this.header?.classList.toggle(this.desktopHeaderWithMenuBarClass);
      stickyHeader.handleBehavior();
    });

    const sentinel = document.querySelector(".sticky-header__threshold");
    const handleStickySentinel = (entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          stickyHeader.disable();
        } else {
          stickyHeader.enable();
        }
      });
    };

    this.stickyHeaderObserver = new IntersectionObserver(handleStickySentinel, {
      root: null,
      rootMargin: `${this.isStickyAlways ? "-160" : "-100"}px 0px 0px 0px`,
      threshold: 0,
    });
    this.stickyHeaderObserver.observe(sentinel);
  }

  disableStickyHeader() {
    if (this.header) {
      // Remove classes added by sticky header
      this.header.classList.remove(
        this.enabledClass,
        this.showClass,
        this.desktopHeaderWithMenuBarClass,
      );
      document.body.classList.remove("page-header-sticky");
      this.desktopMenuBar?.classList.remove("wt-drawer--nav-show");
      this.desktopMenuTrigger?.classList.remove(
        "wt-header__sticky-menu-trigger--active",
      );
    }

    // Remove the scroll event listener
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
      this.scrollHandler = null;
    }

    // Disconnect the IntersectionObserver
    if (this.stickyHeaderObserver) {
      this.stickyHeaderObserver.disconnect();
      this.stickyHeaderObserver = null;
    }
  }

  init() {
    if (this.isSticky) {
      this.enbleStickyHeader();
    } else {
      this.disableStickyHeader();
    }
  }
}

// Nested dropdown navigation functionality
class NestedNavigationHandler {
  constructor() {
    this.initializeDropdowns();
    this.bindEvents();
  }

  initializeDropdowns() {
    this.dropdownTriggers = document.querySelectorAll('[data-has-dropdown="true"]');
    this.subdropdownTriggers = document.querySelectorAll('[data-has-subdropdown="true"]');
    
    // Set initial ARIA states
    this.dropdownTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    
    this.subdropdownTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  bindEvents() {
    // Handle primary dropdown hovers
    this.dropdownTriggers.forEach(trigger => {
      const parentItem = trigger.closest('.wt-header__nav-teaser__item--parent');
      const dropdown = parentItem?.querySelector('.wt-header__nav-teaser__dropdown');
      
      if (parentItem && dropdown) {
        // Mouse enter
        parentItem.addEventListener('mouseenter', () => {
          this.showDropdown(trigger, dropdown);
        });
        
        // Mouse leave
        parentItem.addEventListener('mouseleave', () => {
          this.hideDropdown(trigger, dropdown);
        });
        
        // Keyboard navigation
        trigger.addEventListener('keydown', (e) => {
          this.handleKeyboardNavigation(e, trigger, dropdown);
        });
      }
    });

    // Handle secondary dropdown hovers
    this.subdropdownTriggers.forEach(trigger => {
      const parentItem = trigger.closest('.wt-header__nav-teaser__dropdown-item--parent');
      const subdropdown = parentItem?.querySelector('.wt-header__nav-teaser__subdropdown');
      
      if (parentItem && subdropdown) {
        // Mouse enter
        parentItem.addEventListener('mouseenter', () => {
          this.showSubdropdown(trigger, subdropdown);
        });
        
        // Mouse leave
        parentItem.addEventListener('mouseleave', () => {
          this.hideSubdropdown(trigger, subdropdown);
        });
        
        // Keyboard navigation
        trigger.addEventListener('keydown', (e) => {
          this.handleKeyboardNavigation(e, trigger, subdropdown, true);
        });
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.wt-header__nav-teaser')) {
        this.closeAllDropdowns();
      }
    });

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });
  }

  showDropdown(trigger, dropdown) {
    trigger.setAttribute('aria-expanded', 'true');
    
    // Check if dropdown would overflow viewport and adjust position
    this.adjustDropdownPosition(dropdown);
    
    dropdown.style.opacity = '1';
    dropdown.style.visibility = 'visible';
    dropdown.style.transform = 'translateY(0)';
  }

  hideDropdown(trigger, dropdown) {
    trigger.setAttribute('aria-expanded', 'false');
    dropdown.style.opacity = '0';
    dropdown.style.visibility = 'hidden';
    dropdown.style.transform = 'translateY(-10px)';
    
    // Also hide any open subdropdowns
    const subdropdowns = dropdown.querySelectorAll('.wt-header__nav-teaser__subdropdown');
    const subdropdownTriggers = dropdown.querySelectorAll('[data-has-subdropdown="true"]');
    
    subdropdowns.forEach(subdropdown => {
      subdropdown.style.opacity = '0';
      subdropdown.style.visibility = 'hidden';
      subdropdown.style.transform = 'translateX(-10px)';
    });
    
    subdropdownTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  showSubdropdown(trigger, subdropdown) {
    trigger.setAttribute('aria-expanded', 'true');
    
    // Check if subdropdown would overflow viewport and adjust position
    this.adjustSubdropdownPosition(subdropdown);
    
    subdropdown.style.opacity = '1';
    subdropdown.style.visibility = 'visible';
    subdropdown.style.transform = 'translateX(0)';
  }

  hideSubdropdown(trigger, subdropdown) {
    trigger.setAttribute('aria-expanded', 'false');
    subdropdown.style.opacity = '0';
    subdropdown.style.visibility = 'hidden';
    subdropdown.style.transform = 'translateX(-10px)';
  }

  handleKeyboardNavigation(e, trigger, dropdown, isSubdropdown = false) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (isSubdropdown) {
          if (isExpanded) {
            this.hideSubdropdown(trigger, dropdown);
          } else {
            this.showSubdropdown(trigger, dropdown);
          }
        } else {
          if (isExpanded) {
            this.hideDropdown(trigger, dropdown);
          } else {
            this.showDropdown(trigger, dropdown);
          }
        }
        break;
        
      case 'ArrowDown':
        e.preventDefault();
        if (!isExpanded) {
          if (isSubdropdown) {
            this.showSubdropdown(trigger, dropdown);
          } else {
            this.showDropdown(trigger, dropdown);
          }
        }
        this.focusNextItem(dropdown);
        break;
        
      case 'ArrowUp':
        e.preventDefault();
        this.focusPreviousItem(dropdown);
        break;
        
      case 'ArrowRight':
        if (!isSubdropdown) {
          e.preventDefault();
          this.focusNextMainItem(trigger);
        }
        break;
        
      case 'ArrowLeft':
        if (!isSubdropdown) {
          e.preventDefault();
          this.focusPreviousMainItem(trigger);
        }
        break;
    }
  }

  focusNextItem(dropdown) {
    const links = dropdown.querySelectorAll('a');
    const currentFocus = document.activeElement;
    const currentIndex = Array.from(links).indexOf(currentFocus);
    const nextIndex = currentIndex < links.length - 1 ? currentIndex + 1 : 0;
    links[nextIndex]?.focus();
  }

  focusPreviousItem(dropdown) {
    const links = dropdown.querySelectorAll('a');
    const currentFocus = document.activeElement;
    const currentIndex = Array.from(links).indexOf(currentFocus);
    const previousIndex = currentIndex > 0 ? currentIndex - 1 : links.length - 1;
    links[previousIndex]?.focus();
  }

  focusNextMainItem(currentTrigger) {
    const mainTriggers = document.querySelectorAll('[data-has-dropdown="true"]');
    const currentIndex = Array.from(mainTriggers).indexOf(currentTrigger);
    const nextIndex = currentIndex < mainTriggers.length - 1 ? currentIndex + 1 : 0;
    mainTriggers[nextIndex]?.focus();
  }

  focusPreviousMainItem(currentTrigger) {
    const mainTriggers = document.querySelectorAll('[data-has-dropdown="true"]');
    const currentIndex = Array.from(mainTriggers).indexOf(currentTrigger);
    const previousIndex = currentIndex > 0 ? currentIndex - 1 : mainTriggers.length - 1;
    mainTriggers[previousIndex]?.focus();
  }

  closeAllDropdowns() {
    this.dropdownTriggers.forEach(trigger => {
      const parentItem = trigger.closest('.wt-header__nav-teaser__item--parent');
      const dropdown = parentItem?.querySelector('.wt-header__nav-teaser__dropdown');
      if (dropdown) {
        this.hideDropdown(trigger, dropdown);
      }
    });
  }

  adjustDropdownPosition(dropdown) {
    // Reset any previous positioning classes
    dropdown.classList.remove('dropdown-align-right');
    
    // Get viewport width and dropdown position
    const viewportWidth = window.innerWidth;
    const dropdownRect = dropdown.getBoundingClientRect();
    const dropdownRight = dropdownRect.left + dropdown.offsetWidth;
    
    // If dropdown overflows right edge, align to right
    if (dropdownRight > viewportWidth - 20) {
      dropdown.classList.add('dropdown-align-right');
    }
  }

  adjustSubdropdownPosition(subdropdown) {
    // Reset any previous positioning classes
    subdropdown.classList.remove('subdropdown-align-left');
    
    // Get viewport width and subdropdown position
    const viewportWidth = window.innerWidth;
    const subdropdownRect = subdropdown.getBoundingClientRect();
    const subdropdownRight = subdropdownRect.left + subdropdown.offsetWidth;
    
    // If subdropdown overflows right edge, show on left side
    if (subdropdownRight > viewportWidth - 20) {
      subdropdown.classList.add('subdropdown-align-left');
    }
  }
}

// Initialize nested navigation when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new NestedNavigationHandler();
});

customElements.define("page-header", PageHeaderSection);